import {ServicesUrl} from '../../Config/UrlRuotes';
import {GetToken, MessageResponse} from '../Domain';
import {Action} from 'react-fetching-library';
import {LoginActionResponse} from '../../Context/AuthProvider/AuthProviderActions';
import { ZendeskTokenResponse} from './ZendeskTokenDomain';

export const getZendeskToken : (_data:unknown) => Action<ZendeskTokenResponse> = _data => ({
    method: 'GET',
    endpoint: ServicesUrl.zendesk,
    headers: {
        'Authorization-Token': GetToken()
    }
});

export const getEmailValidationCode : (data:{email: string}) => Action<MessageResponse> = data => ({
    method: 'POST',
    endpoint: ServicesUrl.zendesk + '/mail/code',
    body: data,
    headers: {
        'Authorization-Token': GetToken()
    }
});

export const sendEmailValidationCode :  (data:{email: string, code:string}) => Action<LoginActionResponse> = data => ({
    method: 'POST',
    endpoint: ServicesUrl.zendesk + '/mail/validate',
    body: data,
    headers: {
        'Authorization-Token': GetToken()
    }
});
